export enum STEP_ID {
  PRESCRIPTION_TYPE = "prescription-type",
  ADVANCED_PRESCRIPTION = "advanced-prescription",
  ADD_PRODUCT = "add-product",
}

export enum STEP_IS_VISIBLE {
  USER_LOGGED = "userLogged",
  PRODUCT_SELECTED = "productSelected",
  USER_HAS_SAVED_PRESCRIPTION = "userHasSavedPrescription",
}

export interface Step {
  id: STEP_ID;
  title?: string;
  description?: string;
  manualTitle?: string;
  manualDescription?: string;
  accountTitle?: string;
  accountDescription?: string;
  isVisible?: STEP_IS_VISIBLE[];
}
